import axios from 'axios'
import * as accessTokenInfo from "../../accessToken";
import router from '../../../router'

export const fetchEmployeePayrollList = ({commit, dispatch}, payload) => {
        
    commit('toggleLoadingState', true)
    if(payload.store_list.length === 0 && payload.single_payroll == 'NO') {
        return false
    } else {
        axios.post('/employeePayroll/index.php', payload, accessTokenInfo.accessTokenInfo())
        .then(res => {

            if(res.data.try_again) {
                dispatch('fetchEmployeePayrollList', payload)
            } else {
                commit('setEmployeePayrollList', {response: res.data.response, total: res.data.total, page_number: res.data.page_number, page_number: res.data.page_number})
            }
        })
        .catch(error => {
            commit('displayMessageAlert', {message: error, type: 'Error'})
        })
        .finally( () => {
            commit('toggleLoadingState', false)
        })
    }
}

export const loadFreshPayrollInformation = ({commit}, payload) => {
    
    commit('toggleLoadingState', true)
    axios.post('/employeePayroll/loadFreshPayrollInformation.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {   
        commit('setFreshPayrollInformation', res.data.response)
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const fetchEmployeePayrollData = ({commit, dispatch}, payload) => {
    commit('toggleLoadingState', true)
    axios.post('/employeePayroll/single.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {

        if(res.data.status) {
            
            commit('setEmployeePayrollData', {response: res.data.response})   
            
            if(payload.navigate) {
                if(payload.single_payroll) {
                    router.push('/singlepayrollform/')
                } else {
                    router.push(router.currentRoute.fullPath+'/form/')
                }
                
            }

        } else {
            commit('resetEmployeePayrollData')
        }

    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const submitEmployeePayrollData = ({commit, dispatch}, payload) => {

    commit('toggleLoadingState', true)
            
    axios.post('/employeePayroll/save.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {     
        
        console.log(JSON.stringify(res.data))
        if(res.data.status) {
            commit('displaySuccessNotification', {message: 'Data submitted successfully!!!'});
            dispatch('fetchEmployeePayrollData', {id: res.data.id})
        } else {
            commit('displayMessageAlert', {message: res.data.message, type: 'Error', displayHTML: true});            
        }
        
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const deleteEmployeePayrollData = ({commit, dispatch}, payload) => {

    commit('toggleLoadingState', true)
            
    axios.post('/employeePayroll/delete.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        
        if(res.data.status) {
            commit('displaySuccessNotification', {message: 'Data deleted successfully!!!'});
            if(payload.navBack) {
                router.push(router.currentRoute.fullPath.replace('/form/', ''))
            } else {
                dispatch('fetchEmployeePayrollList', payload.list)
            }
            
        }
        
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const skipProductionWorkFromPayroll = ({commit}, payload) => {
    
    commit('toggleLoadingState', true)
    axios.post('/employeePayroll/skipProductionWorkFromPayroll.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        //commit('displaySuccessNotification', {message: 'Data deleted successfully!!!'});
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const emailPayrollList = ({commit}, payload) => {
    
    commit('toggleLoadingState', true)
    setTimeout(() => {
        commit('displayMessageAlert', {message: 'Admin will receive an email in a few minutes.', type: 'Info'})
        commit('toggleLoadingState', false)
    }, 1000);
    axios.post('/employeePayroll/emailPayrollList.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => { 
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}


// WEBPACK FOOTER //
// ./src/store/modules/employeePayroll/actions.js